import { InfiniteSlider } from './InfiniteSlider';
import { cn } from '../lib/utils';

export function LogoCloud({ className, logos, speed = 80, speedOnHover = 25, reverse = false, size = 'md', ...props }) {
  const sizes = {
    sm: { container: 'h-10', img: 'h-6 md:h-8', text: 'text-sm md:text-base', gap: 'gap-8 md:gap-12', px: 'px-3' },
    md: { container: 'h-12', img: 'h-8 md:h-10', text: 'text-base md:text-lg', gap: 'gap-10 md:gap-16', px: 'px-4' },
    lg: { container: 'h-16', img: 'h-10 md:h-14', text: 'text-lg md:text-xl', gap: 'gap-12 md:gap-20', px: 'px-5' },
  };
  const s = sizes[size] || sizes.md;

  const LogoItem = ({ logo }) => (
    <div className={`flex items-center justify-center ${s.container} ${s.px} flex-shrink-0`}>
      {logo.src ? (
        <img
          alt={logo.alt}
          className={`pointer-events-none ${s.img} select-none object-contain opacity-40 hover:opacity-70 transition-opacity duration-500`}
          height={logo.height || 'auto'}
          loading="lazy"
          src={logo.src}
          width={logo.width || 'auto'}
        />
      ) : (
        <span className={`font-oswald ${s.text} uppercase tracking-[0.15em] text-black/25 whitespace-nowrap select-none`}>
          {logo.alt}
        </span>
      )}
    </div>
  );

  // Few logos: center statically instead of infinite scroll
  if (logos.length <= 5) {
    return (
      <div {...props} className={cn('py-4', className)}>
        <div className={`flex items-center justify-center ${s.gap} flex-wrap`}>
          {logos.map((logo) => <LogoItem key={logo.alt} logo={logo} />)}
        </div>
      </div>
    );
  }

  return (
    <div
      {...props}
      className={cn(
        'overflow-hidden py-4',
        className
      )}
      style={{
        maskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)',
        WebkitMaskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)',
      }}
    >
      <InfiniteSlider gap={64} reverse={reverse} speed={speed} speedOnHover={speedOnHover}>
        {logos.map((logo) => <LogoItem key={logo.alt} logo={logo} />)}
      </InfiniteSlider>
    </div>
  );
}
